import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { LanguageSelector, LanguageSelectorProps } from '@gn-audio/jss-components';

import { ComponentProps } from 'lib/component-props';

export default withDatasourceCheck()<LanguageSelectorProps & ComponentProps>(LanguageSelector);
